import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { setCredentials } from '../../redux/slices/authSlice';
import { useGetCurrentUserAfterSocialLoginMutation } from '../../redux/apis/endpoints/authApi';
import LoadingSpinner from '../../components/common/LoadingSpinner';

const SocialCallback = () => {
  const [processing, setProcessing] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [getCurrentUser, { isLoading }] = useGetCurrentUserAfterSocialLoginMutation();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Parse URL parameters
        const params = new URLSearchParams(location.search);
        const accessToken = params.get('access_token');
        const provider = params.get('provider');
        const returnTo = params.get('return_to') || '/dashboard';

        if (!accessToken) {
          throw new Error('No access token received from social login');
        }

        console.log('Received token from social login. Provider:', provider);
        
        // Store token in localStorage
        localStorage.setItem('token', accessToken);
        
        // Get full user info using the token
        await getCurrentUser(accessToken);
        
        // Redirect to return URL or dashboard
        console.log('Social login successful, redirecting to:', returnTo);
        history.push(returnTo);
      } catch (err) {
        console.error('Social login error:', err);
        setError('Failed to complete social login. Please try again.');
        setProcessing(false);
      }
    };

    handleCallback();
  }, [dispatch, history, location, getCurrentUser]);

  // Show error if something went wrong
  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="bg-red-100 text-red-700 p-4 rounded-lg mb-4">
            {error}
          </div>
          <button
            onClick={() => history.push('/login')}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-brand-teal hover:bg-brand-teal-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-teal"
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  // Show loading state while processing
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <LoadingSpinner />
        <p className="mt-4 text-gray-600">Completing authentication...</p>
      </div>
    </div>
  );
};

export default SocialCallback; 